module.exports = __webpack_public_path__ + "static/media/icouldnthelpbutlook2.3496cc95.mp4";